import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Studio access by role (per the platform role model): developers + approvers
// build/own agents, admins have full platform access, and super_admin ⊇ admin.
// super_admin and approver were previously omitted, locking super_admins out of
// Studio ("Access required") despite having all admin permissions.
const STUDIO_ROLES = new Set(['developer', 'approver', 'admin', 'super_admin']);

export const studioGuard: CanActivateFn = () => {
  const role = (sessionStorage.getItem('current-role') ?? '').toLowerCase();
  if (STUDIO_ROLES.has(role)) return true;
  inject(Router).navigate(['/unauthorized']);
  return false;
};
